<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "from",
    mounted () {},
    components: {
    }
  }
</script>

<style lang="scss" type="text/scss">
  @media screen and (min-width: 769px) {
    .routerView{
      .page-container{
        .sidebar{
          position: fixed;
          top: 48px;
          bottom: 0;
        }
        .content-wrapper{
          padding-left: 260px;
          box-sizing: border-box;
        }
        
      .outer:after {clear:both;content:'.';display:block;width: 0;height: 0;visibility:hidden;}
      }
      .mat{
        height: 48px;
      }
    }
  }
  
</style>



// WEBPACK FOOTER //
// commissionSpbo2.vue?f80b4976